import { Steps } from "antd";
import { formatDateFunction } from "../../../../../utils/helper/utils";
import checkIcon from "../../../../../images/check-icon.svg";
import cancelIcon from "../../../../../images/cancel-icon.svg";
import whatsappIcon from "../../../../../images/whatsapp-icon.svg";
import { useTranslation } from "../../../../../context/TranslationContext";
const TrackingHistory = ({ orderStatusLogs, whatsappNotificationLogs }) => {
  const { t } = useTranslation();
  let items = [];

  if (orderStatusLogs)
    for (let item of orderStatusLogs) {
      if (item.status === "placed") {
        items.push({
          title: t("orderCreated"),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order is created by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
            </div>
          ),
        });
      }
      if (item.status === "send_to_customer") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "editOrderNotification" || row.type === "approvalNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: t("orderSendToCustomer"),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  Order request sent to customer for approval by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "reject") {
        items.push({
          title: (
            <div>
              <span className="text-red-700">{t("orderRejected")}</span>
            </div>
          ),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderRejectedBy")}  {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "request_sent_to_recipient") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "giftRecipientNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (
            <div>
              <span className="text-red-700">{t("orderRequestSentToRecipient")}</span>
            </div>
          ),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderRequestSentToRecipient")} by {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "confirmed") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "orderConfirmedNotification" || row.type === "acceptOrderNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderAccepted")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderHasBeenAcceptedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "processing") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "processingNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderPreparing")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedToPreparingBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "qc_accept") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderAcceptByQc")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenAccptedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "qc_reject") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (
            <div>
              <span className="text-red-700">{t("orderRejectedByQc")}</span>
            </div>
          ),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenRejectedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "under_qa") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "underqaNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderInReview")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedToInReviewBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "ready_to_pick") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "qcApprovedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderReadyToShip")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "out_for_delivery") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "shippedNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderShipped")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "pickup_delivered") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "pickupDeliveredNotification" || row.type === "receipentAcceptNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderReadyToPickupForCustomer")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "delivered") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "deliveredNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("orderCompleted")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "no_show") {
        items.push({
          title: (t("orderNoShow")),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderStatusHasBeenUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}{item.desc ? ` - ${item.desc}` : ""}</div>
            </div>
          ),
        });
      }
      if (item.status === "cancelled" || item.status === "cancle") {
        items.push({
          title: (t("orderCancelled")),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderIsCancelledBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "placed" && item.reason === "Order reactivated from cancelled status") {
        items.push({
          description: (t("awaitingForSendToCustomer")),
        });
      }

      if (item.status === "refund") {
        items.push({
          title: (t("refundAmount")),
          description: (
            <div className="flex flex-col">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderIsRefundBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              <div className="mt-3">{item.reason}</div>
            </div>
          ),
        });
      }
      if (item.status === "rescheduled") {
        items.push({
          title: (t("rescheduled")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderIsRescheduledBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
            </div>
          ),
        });
      }
      if (item.status === "send_gift_receipent") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "giftMakePaymentNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("sendGiftReceipent")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("giftIsSentBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "accpet_gift") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "acceptGiftNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: (t("acceptGift")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("giftAcceptedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "edited") {
        let wpSend = false;
        let wpSendStatus = false;
        // for(let row of whatsappNotificationLogs){
        //   if(row.type==='acceptGiftNotification'){
        //     wpSend = true;
        //     if(row.sendStatus)wpSendStatus = true;
        //   }
        // }
        items.push({
          title: (t("editOrder")),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("orderIsEditedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
      if (item.status === "driver_reassign") {
        items.push({
          title: (t("orderReassignDriver") || "Order Reassign Driver"),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-normal text-gray-200">
                   {t("orderUpdatedBy")} {item?.addedBy?.userType ? item?.addedBy?.userType : null}{" "}
                  <strong>{item?.addedBy ? item?.addedBy?.name : null}</strong> {t("andAssignedDriver")} <strong>{item?.driverName ? `${item.driverName}` : ""}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
            </div>
          ),
        });
      }
      if (item.status === "resend_to_recipient") {
        let wpSend = false;
        let wpSendStatus = false;
        for (let row of whatsappNotificationLogs) {
          if (row.type === "resendAcceptGiftNotification") {
            wpSend = true;
            if (row.sendStatus) wpSendStatus = true;
          }
        }
        items.push({
          title: t("resendGiftReceipent"),
          description: (
            <div className="flex items-start justify-between">
              <div className="flex">
                <div className="text-sm w-[416px] break-words overflow-hidden whitespace-nowrap text-ellipsis text-gray-200">
                  {t("resendGiftReceipentOrder")}
                  <strong> {item?.addedBy ? item?.addedBy?.name : null}</strong>
                </div>
                <div className="text-sm ml-[20px] text-gray-200">{formatDateFunction(item.date, "dd/mm/yyyy", true, "at")}</div>
              </div>
              {wpSend ? (
                <div className="flex items-center gap-3 mt-[-16px]">
                  <div>
                    <img src={whatsappIcon} alt="Filter" className="w-[35px] min-w-[35px] h-[35px]" />
                  </div>
                  <div className="text-sm">{t("notificationSent")}</div>
                  <div>
                    {wpSendStatus ? (
                      <img src={checkIcon} alt="check" className="w-[24px] min-w-[24px] h-[24px]" />
                    ) : (
                      <img src={cancelIcon} alt="close" className="w-[24px] min-w-[24px] h-[24px]" />
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          ),
        });
      }
    }

  if (items.length === 1) items.push({ description: t("awaitingForSendToCustomer") });

  return (
    <div className="px-9 py-5 border-gray-250 border-b w-full">
      <h2 className="text-base font-semibold ">{t("trackingHistory")} </h2>
      <Steps progressDot current={25} direction="vertical" items={items} />
    </div>
  );
};

export default TrackingHistory;
